<template lang="pug">
.order__container(style="margin: 10px 0;    width: auto;")
  div
  hr(style="width: 95%;")
  div(style="color: #1055cc;width: 100%;font-weight: bold;font-size: 28px;padding-top: 20px;")
    center(class="ht-section-title") 我的訂單
    // div
    div(style="padding: 0 0 10px 0%;")
      router-link(:to={name:'info'})
        center
          a(class="ht-header-bttn ht-mobile-hide" size="mini" type="primary") 立即預約
  center(style="" v-if='list.length == 0') 您還沒預約過EZWASH洗衣服務喔！快來預約吧！
  el-card(class="box-card" shadow="always" v-for='order in list' :key='order.order_id' :name='order.order_id')
    div(slot="header" class="clearfix")
      span No.{{ order.order_id }}
      i(class="el-icon-point" style)
    div(class="text item" v-if="order.shipping_method === 1") 收件日期(區間)：{{ order.recipient_sdate }}~{{ order.recipient_edate }}
      i(class="el-icon-point" style)
    div(class="text item" v-if="order.shipping_method === 1") 還件日期(區間)：{{ order.return_sdate }}~{{ order.return_edate }}
      i(class="el-icon-point" style)
    div(class="text item") 訂單金額：{{ (order.price) ? order.price : '估價中' }}
      span(v-if="order.price && order.order_id === order.use_order_id" style="color:red;")  -50元
      //- div(style="display:inline; padding-left: 20px")
        
    // div(class="text item") 寄件方式：{{ (order.shipping_method === 1) ? '一般寄件' : '掌櫃寄件' }}
    // div(class="text item" v-if="order.get_order_id && order.get_order_id === order.use_order_id" style="color:red;") 
    //   center 首次掌櫃預約-折50
    // div(class="text item" v-if="order.get_order_id !== order.use_order_id && order.order_id === order.use_order_id" style="color:red;") 
    //   center 使用優惠券-折50
    
    p
      center
        el-link(type="primary"  v-if="order.price && order.pay_status == 0" @click="openOnLinePayment(order.order_id, 1)") 
          img(src="@/assets/ecpay_logo.png" width="50px")
          span 綠界刷卡
    p
      center
        el-link(type="primary"  v-if="order.price && order.pay_status == 0" @click="openOnLinePayment(order.order_id, 2)") 
          img(src="@/assets/linepay_logo.png" width="50px")
          span LinePay付款
    p
      center(v-if="order.price && !order.remittanceAccount && order.pay_status != 1")
        el-link(type="primary" @click="open(order.order_id, order.price, order.order_id === order.use_order_id)") 
          //- img(src="@/assets/ecpay_logo.png" width="30px")
          span 手動匯款
    
    el-divider

    el-row(:gutter="20")
      el-col(:span="11" style="text-align: center;") 
        i(class="el-icon-money") 
        br
        el-tag(effect="plain" :type="showPayStatus(order.price, order.remittanceAccount, order.pay_status, true)") {{ showPayStatus(order.price, order.remittanceAccount, order.pay_status) }}
      el-col(:span="1")
        el-divider(direction="vertical")
      el-col(:span="11" style="text-align: center;") 
        i(class="el-icon-truck") 
        br
        el-tag(effect="plain" :type="showStatus(order.status, true)") {{ showStatus(order.status) }}
    div(class="text item" v-if="order.price && order.remittanceAccount") 匯款帳號後四碼：{{ order.remittanceAccount }}

    center(style="font-size: 1px;margin-top: 20px;color: darkgray;") 訂單日期：{{ order.created_at }}
  // center
    a(href="https://ezwash.tw/")
      el-button(type="primary") 回首頁

  el-dialog(title="掌櫃取件流程" :visible.sync="dialogTableVisible1" width="80%") 
    img(width="100%" src="@/assets/取件流程圖/1.png")
    img(width="100%" src="@/assets/取件流程圖/2-1.png")
    img(width="100%" src="@/assets/取件流程圖/2-2.png")
    img(width="100%" src="@/assets/取件流程圖/3.png")
    img(width="100%" src="@/assets/取件流程圖/4.png")
    img(width="100%" src="@/assets/取件流程圖/5.png")
    img(width="100%" src="@/assets/取件流程圖/6.png")
    img(width="100%" src="@/assets/取件流程圖/7.png")

  el-dialog(title="掌櫃寄件流程" :visible.sync="dialogTableVisible2" width="80%") 
    img(width="100%" src="@/assets/寄件流程圖/1.png")
    img(width="100%" src="@/assets/寄件流程圖/2.png")
    img(width="100%" src="@/assets/寄件流程圖/3.png")
    img(width="100%" src="@/assets/寄件流程圖/4.png")
    img(width="100%" src="@/assets/寄件流程圖/5.png")
    img(width="100%" src="@/assets/寄件流程圖/6.png")
    img(width="100%" src="@/assets/寄件流程圖/7.png")
  
</template>

<script>
import Header from './../Header'
import Cookies from 'js-cookie'
import { getOrder, remittance } from '@/api'
export default {
  name: 'OrderList',
  data () {
    return {
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      dialogTableVisible3: false,
      list: [],
      activeName: null,
      userTel: Cookies.get('phone')
    }
  },
  created () {
    if(!this.userTel){
      Cookies.set('redirect', 'orderList')
      this.$router.replace({ name: 'LoginLndex' })
      return
    }
    this.fetchData()
  },
  methods: {
    paymentOnline(order_id){
      location.href='https://backstage.ezwash.com.tw/payment/onePayment?order_id='+ order_id
    },
    paymentOlineLinepay(order_id){
      location.href='https://backstage.ezwash.com.tw/payment/linePay/linePayment?order_id='+ order_id
    },
    open(order_id, price, has_discount) {
      let total = has_discount ? price - 50 : price 
      this.$prompt(`「華南銀行-代碼 008，134-10-002097-1」，請麻煩在轉帳完成後line我們說一聲，或於此輸入您的匯款帳號末4碼供人員對帳，謝謝您`, `總金額:${total}元`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[0-9]{4}$/,
        inputErrorMessage: '格式不正确'
      }).then(({ value }) => {

        remittance({'remittanceAccount':value, order_id: order_id}).then(res => {
            
          this.$message({
            type: 'success',
            message: '註記成功，請等待易立洗服務人員檢核'
          });

          this.fetchData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    openOnLinePayment(order_id, status) {
      if(status == 1){
        this.paymentOnline(order_id)
      }else if(status == 2){
        this.paymentOlineLinepay(order_id)
      }
      //  this.$confirm(`提醒您，使用線上付款，需加收3%的手續費唷～`, `線上付款`, {
      //   confirmButtonText: '確定',
      //   cancelButtonText: '取消',
      // }).then(({ value }) => {
      //   if(status == 1){
      //     this.paymentOnline(order_id)
      //   }else if(status == 2){
      //     this.paymentOlineLinepay(order_id)
      //   }
      // })
    },
    showPayStatus(price, remittanceAccount, pay_status, is_get_type = false) {
      let text ;
      let type = "info"
       if(!price){ 
        text = '待估價'
       }else if(price && !remittanceAccount && pay_status !== 1){ 
        text = '尚未匯款'
        type = 'danger'
       }else if(price && remittanceAccount && pay_status !== 1){ 
        text = '您已匯款，等待檢核中'
       }else if(price && pay_status === 1){ 
        text = '完成'
        type = 'success'
       } 
      if(is_get_type) {
      console.log(type)
        return type
      }
      return text;
    },
    showStatus(status, is_get_type = false) {
      let text ;
      let type = "info"
       if(status === 0){ 
        text = '未收件'
        type = 'warning'
       }else if(status === 1){ 
        text = '您已寄件(掌櫃)'
       }else if(status === 2){ 
        text = '清洗中'
       }else if(status === 3){ 
        text = '待還件'
       }else if(status === 4){ 
        text = '還件中'
        type = 'warning'
       }else if(status === 5){ 
        text = '完成'
        type = 'success'
       }else if(status === 6){ 
        text = '已取消'
        type = 'danger'
       }else if(status === 7){ 
        text = '已退件'
        type = 'danger'
       }

      if(is_get_type) {
      console.log(type)
        return type
      }
      return text
    },
    fetchData () {
      getOrder({'userTel':this.userTel}).then(res => {
        console.log(res.data)
        this.list = res.data     
      })
    },
    statusStyleFilter (status) {
      const statusMap = {
        2: 'success',
        1: 'primary',
        0: 'danger'
      }
      return statusMap[status]
    },
    statusNameFilter (status) {
      const statusMap = {
        2: '已完成',
        1: '運送中',
        0: '待出貨'
      }
      return statusMap[status]
    }
  }
}
</script>


<style>
  .text {
    font-size: 16px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    margin-bottom: 10px;
  }
</style>

<style lang="scss" scoped>
.order {
  &__container {
    width: 100vw;
    box-sizing: border-box;
    padding: 20px;
    margin: 40px 0;
  }
  &__item {
    padding: 14px 0;
  }
  &__info {
    border-top: 1px solid #ebeef5;
    &__detail {
      margin: 10px;
    }
  }
}
.el-collapse-item {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px;
  & /deep/ .el-collapse-item__header {
    flex-direction: column;
    height: auto;
    line-height: unset;
    align-items: unset;
    justify-content: unset;
    font-size: 16px;
    border: none;
    i {
      display: none;
    }
  }
}
.check_code{
  background-color: rgba(158, 158, 158, 0.24);
    color: black;
    font-size: 16px;
    margin: 15px;
    line-height: 2;
    text-align: center;
}

@media (min-width: 500px) {
.box-card {
    width: 45%;
    display: inline-table;
    margin: 2vw;
}
}
@media (min-width: 1040px) {
.box-card {
    width: 29%;
    display: inline-table;
    margin: 2vw;
}
}
// @media (min-width: 900px) {
// .box-card {
//     width: 30%;
//     display: inline-table;
//     margin: 1.5vw;
// }
// }

</style>